import { render, staticRenderFns } from "./RunnitBoardOnboardingBanner.vue?vue&type=template&id=34919a2c&scoped=true"
import script from "./RunnitBoardOnboardingBanner.vue?vue&type=script&lang=ts"
export * from "./RunnitBoardOnboardingBanner.vue?vue&type=script&lang=ts"
import style0 from "./RunnitBoardOnboardingBanner.vue?vue&type=style&index=0&id=34919a2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34919a2c",
  null
  
)

export default component.exports